module.exports = __webpack_public_path__ + "img/Arrow down Icon - charcoal.56718c69.svg";